import {NewsItem} from "../types/news";
import {client, database_id} from "../lib/appwrite"
import {Databases} from "appwrite";
import {v4 as uuidv4} from "uuid";

const NEWS_COLLECTION_ID = "677109cb0009c2d3ff0d"

const databases = new Databases(client);

export const newsService = {

  async list(queries: string[] = []): Promise<{ newsList: NewsItem[], totalCount: number }> {
    try {
      const response = await databases.listDocuments(
        database_id,
        NEWS_COLLECTION_ID,
        [
          ...queries
        ]
      );
      const newsList = response.documents.map(doc => doc as unknown as NewsItem);
      const totalCount = response.total
      return {
        newsList,
        totalCount
      };
    } catch (error) {
      console.error('Error listing news:', error);
      throw error;
    }
  },


  async createNews(data: NewsItem): Promise<NewsItem> {
    try {
      const newsItem = await databases.createDocument(
        database_id,
        NEWS_COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as NewsItem;

      return newsItem;
    } catch (error) {
      console.error('Помилка створення новини:', error);
      throw error;
    }
  },

  async update(data: NewsItem): Promise<NewsItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedItem = await databases.updateDocument(
        database_id,
        NEWS_COLLECTION_ID,
        id,
        correctData
      ) as unknown as NewsItem;
      return updatedItem;
    } catch (error) {
      console.error('Помилка оновлення новини!', error);
      throw error;
    }
  },


  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        NEWS_COLLECTION_ID,
        id
      );
    } catch (error) {
      console.error('Помилка видалення новини:', error);
      throw error;
    }
  },

  async getNewsItem(id: string): Promise<NewsItem> {
    try {
      const current = await databases.getDocument(
        database_id,
        NEWS_COLLECTION_ID,
        id
      ) as unknown as NewsItem;

      return current;
    } catch (error) {
      console.error('Помилка завантаження новини:', error);
      throw error;
    }
  }


}
